import { shallowMount } from "@vue/test-utils";
import BannerFinanzasOferta from "@/components/core/custom/BannerFinanzasOferta.vue";

describe("BannerFinanzasOferta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(BannerFinanzasOferta);
  });

  it("Renders del component BannerFinanzasOferta", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
